<template>
  <div>
    <ScrollView
      class="DashScrollContainer"
      :refreshing="refreshing"
      @onRefresh="onRefresh"
      :empty="data.length === 0"
    >
      <div v-for="(item, index) in data" :key="index" class="StyleWrapper">
        <div class="StyleTextContainer">
          <span class="StyleFontTitle">
            {{ $formatter(item.cantidad, 0, ".00") }} - {{ item.titulo }}
          </span>
          <span class="StyleFontDetail">
            {{ item.detalle }}
          </span>
        </div>
        <div class="StyleContentBar">
          <div
            class="StyleBar"
            :data-porcentaje="`${item.porcentaje}%`"
            :style="`width: ${item.porcentaje}%`"
          />
        </div>
      </div>
      <template slot="Empty">
        <slot name="Empty" />
      </template>
    </ScrollView>
  </div>
</template>

<script>
import { makeCSS } from "./utils";

export default {
  name: "DrillDown",
  components: {},
  props: {
    refreshing: {
      type: Boolean,
      default: false
    },
    onRefresh: {
      type: Function,
      default: () => {}
    },
    data: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      noItems: { noResults: "Sin Resultados", noItems: "Sin Resultados" }
    };
  },
  computed: {},
  methods: {
    makeCSS(v) {
      return makeCSS(v);
    }
  }
};
</script>

<style lang="scss" scoped>
.DashScrollContainer {
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: space-evenly;
}

.StyleWrapper {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  width: 100%;
}
.StyleBar {
  height: 20px;
  width: 100%;
  background-color: #fb8e2c;
  border-radius: 5px;
  margin-top: 5px;
  margin-bottom: 5px;
}
.StyleFontTitle {
  font-weight: bold;
  font-size: 22px;
  color: #000;
  font-size: 20;
}
.StyleFontDetail {
  font-weight: bold;
  font-size: 22px;
  color: #000;
  font-size: 15;
}
.StyleTextContainer {
  max-width: calc(100% - 700px);
  width: 100%;
}
.StyleContentBar {
  width: 700px;
  display: flex;
  align-items: center;
}
</style>
